<template>
<transition name="Right">
  <div class="income">
    <Header>
      <span slot="center">收益报表</span>
    </Header>
    <div class="user_info">
      <div class="money">
        <div>
          账户余额(元)
          <div class="blod">
            {{incomeData.balance | toFixed2	}}
          </div>
        </div>
        <div class="btn"  @click="toDetail('/withdraw')">
          <van-icon name="card" /> 去提现
        </div>
      </div>
      <div class="income">
        <div>
          累计收益(元)
          <div>
            {{incomeData.sumIncome | toFixed2	}}
          </div>
        </div>
        <div>
          已提现(元)
          <div>
            {{incomeData.cashAmount | toFixed2	}}
          </div>
        </div>
        <div>
          未结算(元)
          <div>
            {{incomeData.unsettledAmount | toFixed2	}}
          </div>          
        </div>
      </div>
    </div>
    <div class="time_nav" >
      <div :class="{active:timeIndex===1}" id="1" @click="changeTime">今日</div>
      <div :class="{active:timeIndex===2}" id="2" @click="changeTime">昨日</div>
      <div :class="{active:timeIndex===3}" id="3" @click="changeTime">本月</div>
      <div :class="{active:timeIndex===4}" id="4" @click="changeTime">上月</div>
    </div>
    <div class="income_card">
      <div class="item">
        <div class="i_title">我的订单收益</div>
        <div class="i_content">
          <div>
            付款笔数
            <div >
              <span v-if="timeIndex===1">{{incomeData.dayFkCnt	}}</span>
              <span v-else-if="timeIndex===2">{{incomeData.lastDayFkCnt	}}</span>
              <span v-else-if="timeIndex===3">{{incomeData.monthFkCnt	}}</span>
              <span v-else-if="timeIndex===4">{{incomeData.lastMonthFkCnt	}}</span>
            </div>
          </div>
          <div>
            预估收益
            <div class="money">
              <span v-if="timeIndex===1">{{incomeData.dayEstimate}}</span>
              <span v-else-if="timeIndex===2">{{incomeData.lastDayEstimate}}</span>
              <span v-else-if="timeIndex===3">{{incomeData.monthEstimate}}</span>
              <span v-else-if="timeIndex===4">{{incomeData.lastMonthEstimate	}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 团队收益 -->
      <!-- <div class="item">
        <div class="i_title">团队订单收益</div>
        <div class="i_content">
          <div>
            付款笔数
            <div>
              <span v-if="timeIndex===1">{{incomeData.dayFkCnt	}}</span>
              <span v-else-if="timeIndex===2">{{incomeData.lastDayFkCnt	}}</span>
              <span v-else-if="timeIndex===3">{{incomeData.lastMonthFkCnt	}}</span>
              <span v-else-if="timeIndex===4">{{incomeData.monthFkCnt	}}</span>
            </div>
          </div>
          <div  class="money">
            预估收益
            <div>
              <span v-if="timeIndex===1">{{incomeData.dayEstimate}}</span>
              <span v-else-if="timeIndex===2">{{incomeData.lastDayEstimate}}</span>
              <span v-else-if="timeIndex===3">{{incomeData.lastMonthEstimate}}</span>
              <span v-else-if="timeIndex===4">{{incomeData.monthEstimate	}}</span>
            </div>
          </div>
        </div>     
      </div> -->
    </div>
    <div class="white_bar" @click="toRecord(1)">
      余额明细
    </div>
    <div class="white_bar" @click="toRecord(2)">
      提现记录
    </div>
  </div>
</transition>
</template>

<script>
import Header from "@/components/Header/index";
import { getIncomeStatement } from "@/api/userBalance";
export default {
  name:'IncomeStatement',
  components:{
    Header
  },
  data(){
    return{
      timeIndex: 1,
      incomeData:{
        balance: 0,
        cashAmount: 0,
        dayEstimate: 0,
        dayFkCnt: 0,
        lastDayEstimate: 0,
        lastDayFkCnt: 0,
        lastMonthEstimate: 0,
        lastMonthFkCnt: 0,
        monthEstimate: 0,
        monthFkCnt: 0,
        sumIncome: 0
      }
    }
  },
  created(){
    var form = new FormData();
    form.append("userId",this.$store.state.userId); 
    getIncomeStatement(form).then(res=>{
      this.incomeData = res.data
    })

  },
  methods:{
    changeTime(e){
      this.timeIndex = e.target.id * 1
    },
    toRecord(page){
      this.$router.push('/record?page='+page)
    },
    toDetail(path){
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less" scoped>
.income{
  .user_info{
    width: 100vw;
    height: 15rem;
    background-color: #F63A25;
    margin-top: -1px;
    // display: flex;
    position: relative;
    // margin-bottom: 3.6rem;
    .money{
      display: flex;
      justify-content: space-between;
      width: 92vw;
      margin-left: 4vw;
      color: white;
      font-size: 1.4rem;
      height: 8rem;
      align-items: center;
      .blod{
        font-size: 2.2rem;
        margin-top: 1rem;
      }
      .btn{
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 1.4rem;
        background-color: #fff;
        color: red;
        width: 6.2rem;
        height: 1.3rem;
        padding: 5px;
        text-align: center;
        border-radius: 10px;
        // line-height: 1.3rem;
        
      }
    }
    .income{
      display: flex;
      justify-content: space-between;
      color: white;
      text-align: center;
      font-size: 1.4rem;
      width: 92vw;
      margin-left: 4vw;
      margin-top: 10px;
      div{
        color: rgba(255, 255, 255, 0.7);
        div{
          margin-top: 10px;
          font-size: 1.6rem;
          color: white;
          font-weight: 600;
        }        
      }

    }
  } 
  .time_nav{
    width: 100vw;
    height: 4rem;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    font-size: 1.4rem;
    align-items: center;
    color: rgb(100, 100, 100);
    div{
      width: 2.8rem;
      white-space: nowrap;
      box-sizing: border-box;
      padding: 1rem 0;
      
    }
    .active{
      border-bottom: 4px solid rgb(250, 10, 10);
      font-size: 1.6rem;
    }
  }
  .income_card{
    width: 94vw;
    margin-left: 3vw;
    margin-top: 3vw;
    padding: 4vw;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 6px;
    height: 16rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .item{
      // height: 4rem;
      // margin-bottom: 10px;
      .i_title{
        padding-bottom: 4vw;
        font-size: 1.6rem;
        border-bottom: 1px solid rgba(100, 100, 100, .1);
      }
      .i_content{
        display: flex;
        justify-content: space-around;
        margin: 2rem;
        text-align: center;
        font-size: 1.6rem;
        .money{
          span{
            &::before{
              content: '￥';
              font-size: 1rem;
            }
          }
        }
        div{
          div{
            margin-top: 1.4rem;
            font-size: 1.6rem;
            font-weight: 600;
          }
        }
        // height: 10rem;
      }
    }
  }
  .white_bar{
    margin-top: 3vw;
    width: 100vw;
    height: 4rem;
    padding: 1rem 1.6rem;
    box-sizing: border-box;
    font-size: 1.5rem;
    background-color: #fff;
    line-height: 2rem;
    
  }
}


</style>